const MANDATORY_SUBJECTIVITIES = [
  {
    key: 1,
    text: "Completed and signed Owner's EDGE Application confirming project detail"
  },
  {
    key: 2,
    text: "Acceptance or Rejection of TRIA"
  }
]

const isBlank = (text) => {
  return !(text && text.length > 0);
}

const getBySideWalkMaintainence = (submission, within10days = false) => {
  const { sidewalkMaintaining, sidewalkDetails } = submission;
  if (sidewalkMaintaining === "Other") {
    if (isBlank(sidewalkDetails)) {
      if (within10days) {
        return "Who is responsible for maintaining the site/ sidewalks (including snow/ice removal)?";
      }
    }
  }
  return "";
}


const getAuditorInformation = (submission, within10days = false) => {
  const { AuditorInfo } = submission;
  if (within10days) {
    if (isBlank(AuditorInfo.auditorEmail) && !isBlank(AuditorInfo.auditorName) && !isBlank(AuditorInfo.auditorPhone)) {
      return "Provide audit contact e-mail.";
  }
  else if (!isBlank(AuditorInfo.auditorEmail) && isBlank(AuditorInfo.auditorName) && !isBlank(AuditorInfo.auditorPhone)) {
      return "Provide audit contact name.";
  }
  else if (!isBlank(AuditorInfo.auditorEmail) && !isBlank(AuditorInfo.auditorName) && isBlank(AuditorInfo.auditorPhone)) {
      return "Provide audit contact phone number.";
  }
  else if (isBlank(AuditorInfo.auditorEmail) && isBlank(AuditorInfo.auditorName) && !isBlank(AuditorInfo.auditorPhone)) {
      return "Provide audit contact name and e-mail.";
  }
  else if (isBlank(AuditorInfo.auditorName) && isBlank(AuditorInfo.auditorPhone) && !isBlank(AuditorInfo.auditorEmail)) {
      return "Provide audit contact name and phone number.";
  }
  else if (isBlank(AuditorInfo.auditorPhone) && isBlank(AuditorInfo.auditorEmail) && !isBlank(AuditorInfo.auditorName)) {
      return "Provide audit contact e-mail and phone number.";
  }
  else if ((isBlank(AuditorInfo.auditorPhone) && isBlank(AuditorInfo.auditorEmail) && isBlank(AuditorInfo.auditorName))) {
      return "Provide audit contact name, e-mail and phone number."
  }
  }
return ""
}

const getByVerticalExpansion = (submission, within10days = false) => {
  const { verticalExpansion, type } = submission;
  if (verticalExpansion && verticalExpansion === 'true') {
    if (within10days) {
      return "Provide a letter from the architect and/or engineer on their letter head stating the structure can withstand the planned height addition.";
    }
  }
  return '';
}

const getByVerticalExpansion2 = (submission, within10days = false) => {
  const { verticalExpansion, type } = submission;
  if (verticalExpansion && verticalExpansion === 'true') {
    if (within10days) {
      return "Provide a letter from the GC that the structural engineer's guidance will be strictly followed.";
    }
  }
  return '';
}

const getByVerticalExpansionOCP = (submission, within10days = false) => {
  const { verticalExpansion } = submission;
  if (verticalExpansion && verticalExpansion === 'true') {
      return "Letter from the Architect stating the existing building will be able to support the additional floors";
  }
  return '';
}

const getByOccupancy = (submission, within10days = false) => {
  const { occupancy } = submission;
  if (occupancy && occupancy === 'true') {
    if (within10days) {
      return "COI showing occupancy exposure is covered elsewhere.";
    }
  }
  return '';
}

const getByOccupancyDescription = (submission, within10days = false) => {
  const { occupancy, occupancyProtectionDescription } = submission;
  if (occupancy && occupancy === 'true' && isBlank(occupancyProtectionDescription) && !within10days) {
    return 'How are the occupants protected from construction work/activities?';
  }
  return '';
}

const getByOccupancyPercentage = (submission, within10days = false) => {
  const { occupancy, occupancyPercentage } = submission;
  if (occupancy && occupancy === 'true' && isBlank(occupancyPercentage) && !within10days) {
    return 'What percentage of the building will be occupied?';
  }
  return '';
}

const getByTowerCraneCondition1 = (submission, within10days = false) => {
  const { towerCraneUse } = submission;
  if (towerCraneUse && towerCraneUse === 'true' && !within10days) {
    return "COIs showing named CG2010, CG2037, PNC and WOS in favor of our insured for the GC and the crane operator, showing a combined minimum limit of $75M, if the tower crane exclusion is to be removed.";
  }
  return '';
}

// const getByTowerCraneCondition2 = (submission, within10days = false) => {
//   const { towerCraneUse } = submission;
//   if (towerCraneUse && towerCraneUse === 'true') {
//     if (within10days) {
//       return "We require endorsements CG2010, CG2037, and PNC specifically naming our Named Insured and Additional Insured’s as Additional Insured on both the General Contractor and Tower Crane Subcontractor’s policies.";
//     }
//     return 'Endorsements CG2010, CG2037 and PNC specifically naming our NI and AI’s as Additional Insured on GC and Tower Crane Subcontractor’s policies.';
//   }
//   return '';
// }

const getByWorkStarted = (submission, within10days = false) => {
  const { workStarted } = submission;
  if (workStarted && workStarted === 'true' && within10days) {
    return "NKLL for the period of time from the date the work began to the date the form is signed, or the effective date of our policy, whichever is later.";
  }
  return '';
}

const getByotherSubcontractorsCondition = (submission, within10days = false) => {
  const { otherSubcontractors, otherSubcontractorsPaid } = submission;

  if (otherSubcontractorsPaid === 'true') {
    if (isBlank(otherSubcontractors)) {
      return "The owner is paying, contracting or supervising subs other than GC. Please provide details on number of contractors, trades and scope of work. ";
    }
  }

  return "";
}


const getByConstructionSite = (submission, within10days = false) => {
  const { constructionSite } = submission;
  if (constructionSite === 'Unknown') {
    if (!isBlank(constructionSite)) {
        return "Confirmation if New or Remodel/Renovation ";
    }
  }
  return "";
}

const getByOccupancyIngression = (submission, within10days = false) => {
  const { occupancy, occupancyDescription } = submission;
  if (occupancy && occupancy === 'true' && occupancyDescription === 'Unknown') {
    return 'Confirm if there is a separate ingress/egress for construction workers';
  }
  return '';
}


const getByProjectName = (submission, within10days = false) => {
  const { projectName } = submission;
  if (isBlank(projectName)) {
    if (within10days) {
      return "Confirm Project Name";
    }
  }
  return "";
}

const getSLBByEffectiveDate = (submission, within10days = false) => {
  const startDate = new Date(submission.anticipatedStartDate).getTime();
  let SLBEffectiveDate = new Date('2024-02-26').getTime();
  if (startDate>=SLBEffectiveDate && !within10days) {
    return "The attached SLB Data sheet must be completed and returned to us. *This form is required at the time of binding for all Surplus Lines policies. There may be a delay in the issuance of the policy if the requested information is not provided in a timely manner";
  }
  return "";
}

const getByNYCHAProject = (submission, within10days = false) => {
  const { nycha } = submission;
  if (nycha === "true") {
    if (within10days) {
      return "Confirm if the project is in NY if it is a NYC Housing Authority (NYCHA) Project";
    }
  }
  return "";
}

const getByGLExpirationDate = (submission, within10days = false) => {
  const { generalContractorKnown, generalContractorExpirationDate } = submission;
  if (generalContractorKnown === 'true' && isBlank(generalContractorExpirationDate) && within10days) {
    return "Advise expiration date of the GC's GL policy";
  }
}

const getByResidential = (submission, within10days = false) => {
  const { projectType, residentials } = submission;
  if (projectType === 'Residential' && isBlank(residentials) && !within10days) {
    return "Provide total # of units, lots, and or homes in the finished project";
  }
  return "";
}

const getByRenovation = (submission, within10days = false) => {
  const { structuralWork, StructuralWorkPerformedDetail } = submission;
  if (structuralWork && structuralWork === 'true' && isBlank(StructuralWorkPerformedDetail) && !within10days) {
     return "Provide all details regarding structural work to be performed";
  }
  return "";
}

const getBySquareFootage = (submission, within10days = false) => {
  const { squareFootage } = submission;
  if (isBlank(squareFootage)) {
    if (within10days) {
      return "Square footage of the finished project";
    }
  }
  return "";
}

const getBysquareFootagePercent = (submission, within10days = false) => {
  const { constructionSite, squareFootage, squareFootagePercent } = submission;
  if (constructionSite === 'Remodel/Renovation' && !isBlank(squareFootage) && isBlank(squareFootagePercent)) {
    if (within10days) {
      return "Percentage of total square footage that is being renovated";
    }
  }
  return ""
}

const getNumberOfStories = (submission, within10days = false) => {
  const { storiesFinishedProject } = submission;
  if (isBlank(storiesFinishedProject)) {
    if (within10days) {
      return "Number of stories of the finished project";
    }
  }
  return "";
}

const getBySpecificFloorsDetails = (submission, within10days = false) => {
  const { specificFloors, specificFloorsDetails } = submission;
  if (specificFloors === 'true' && isBlank(specificFloorsDetails) && !within10days) {
    return "Provide details of work being limited to specific floors";
  }
  return "";
}

const getByEightfeet = (submission, within10days = false) => {
  const { eightFeet } = submission;
  if (eightFeet === "true" && !within10days) {
    return "Provide details of all work performed more than 8 feet below grade.";
  }
  return "";
}

const getByPortionComplition = (submission, within10days = false) => {
  const { portionSold, portionSoldSales } = submission;
  if (portionSold === 'true' && isBlank(portionSoldSales)) {
    if (within10days) {
      return "What is the approximate sales price per unit/home/lot/total project?";
    }
  }
  return "";
}

const getByDemolitionName = (submission, within10days = false) => {
  const { exteriorDemo, demolitionDetailsContractor } = submission;
  if (exteriorDemo === 'true' && isBlank(demolitionDetailsContractor)) {
    if (within10days) {
      return "What is the name of the demolition contractor being hired?";
    }
  }
  return "";
}

const getByDemolitionDetailsStories = (submission, within10days = false) => {
  const { exteriorDemo, demolitionDetailsStories } = submission;
  if (exteriorDemo === 'true' && isBlank(demolitionDetailsStories) && !within10days) {
    return "Provide Total # of stories being demolished?";
  }
  return "";
}

const getByDemolitionDetailsMethod = (submission, within10days = false) => {
  const { exteriorDemo, demolitionDetailsMethod } = submission;
  if (exteriorDemo === 'true' && isBlank(demolitionDetailsMethod) && !within10days) {
    return "Describe methods used for demolition (any use of ball & chain or blasting)?";
  }
  return "";
}

const getByDemolitionDetailsMonths = (submission, within10days = false) => {
  const { exteriorDemo, demolitionDetailsMonths } = submission;
  if (exteriorDemo === 'true' && isBlank(demolitionDetailsMonths) && !within10days) {
    return "How many months will demolition take?";
  }
  return "";
}

const getByDemolitionDetailsPrecautions = (submission, within10days = false) => {
  const { exteriorDemo, demolitionDetailsPrecautions } = submission;
  if (exteriorDemo === 'true' && isBlank(demolitionDetailsPrecautions) && !within10days) {
    return "Describe the safety precautions in place to protect pedestrians & workers.";
  }
  return "";
}

const getByWorkStartDate = (submission, within10days = false) => {
  const { workStarted, workStartDate } = submission;
  if (workStarted === 'true' && isBlank(workStartDate) && !within10days) {
    if (within10days) {
      return "";
    }
    return "When did work begin?";
  }
  return "";
}

const getByWorkStartDescription = (submission, within10days = false) => {
  const { workStarted, workStartDescription } = submission;
  if (workStarted === 'true' && isBlank(workStartDescription) && !within10days) {
    return "Why has work started & stopped/why is coverage being replaced?";
  }
  return "";
}

const getByWorkCompleteDescription = (submission, within10days = false) => {
  const { workStarted, workStartDescription } = submission;
  if (workStarted === 'true' && isBlank(workStartDescription) && !within10days) {
    return "Confirm details of work completed to date, including costs";
  }
  return "";
}

const getByWorkRemainDescription = (submission, within10days= false) => {
  const { workStarted, workRemainDescription } = submission;
  if (workStarted === 'true' && isBlank(workRemainDescription) && !within10days) {
    return "Confirm details of work remaining, including costs";
  }
  return "";
}

const getByPriorGcResponsible = (submission, within10days = false) => {
  const { workStarted, priorGcResponsible } = submission;
  if (workStarted === 'true' && isBlank(priorGcResponsible)) {
    if (within10days) {
      return "What is the name of the GC responsible for prior work?";
    }
  }
  return "";
}

const getByPriorworkNI = (submission, within10days = false) => {
  const { workStarted, priorworkNI } = submission;
  if (workStarted === 'true' && isBlank(priorworkNI)) {
    if (within10days) {
      return "Name of the GL carrier providing coverage for NI during prior work";
    }
  }
  return "";
}

const getSubsidenceRemoval = (additionalCoverages, within10days = false, reset = false) => {
  const {subsidence} = additionalCoverages;
  if ((subsidence && subsidence.selected === true && !within10days) || reset) {
    return "Confirmation that the direct hired contractor's policy does not contain a subsidence exclusion"
  } else {
    return ""
  }
}
const getPollutionExclusion = (additionalCoverages, within10days = false, reset = false) => {
  const {pollution} = additionalCoverages;
  if ((pollution && pollution.selected === true && !within10days) || reset) {
    return "Confirmation that the direct hired contractor's policy contains a hostile fire exception on their pollution exclusion"
  } else {
    return ""
  }
}

const getSubjectivitiesOI = (submission, within10days = false) => {
  const subjectivities = within10days ? []: MANDATORY_SUBJECTIVITIES.slice();
  let nextKey = within10days ? 0 :Math.max.apply(Math, subjectivities.map(sub => sub.key)) + 1;
  const additionalCoverages = submission && submission.coverages && submission.coverages.gl ? submission.coverages.gl.additional : [];
  const newSubs = [
    getSLBByEffectiveDate(submission, within10days),
    getByOccupancy(submission, within10days),
    getByOccupancyDescription(submission, within10days),
    getByTowerCraneCondition1(submission, within10days),
    getByVerticalExpansion(submission, within10days),
    getByVerticalExpansion2(submission, within10days),
    getByOccupancyPercentage(submission, within10days),
    getBySideWalkMaintainence(submission, within10days),
    getByProjectName(submission, within10days),
    getByResidential(submission, within10days),
    getByRenovation(submission, within10days),
    getBySquareFootage(submission, within10days),
    getBysquareFootagePercent(submission, within10days),
    getNumberOfStories(submission, within10days),
    getBySpecificFloorsDetails(submission, within10days),
    getByEightfeet(submission, within10days),
    getByPortionComplition(submission, within10days),
    getByDemolitionName(submission, within10days),
    getByDemolitionDetailsStories(submission, within10days),
    getByDemolitionDetailsMethod(submission, within10days),
    getByDemolitionDetailsMonths(submission, within10days),
    getByDemolitionDetailsPrecautions(submission, within10days),
    getByWorkStarted(submission, within10days),
    getByWorkStartDate(submission, within10days),
    getByWorkStartDescription(submission, within10days),
    getByWorkCompleteDescription(submission, within10days),
    getByWorkRemainDescription(submission, within10days),
    getByPriorGcResponsible(submission, within10days),
    getByPriorworkNI(submission, within10days),
    getSubsidenceRemoval(additionalCoverages, within10days),
    getPollutionExclusion(additionalCoverages, within10days),
    getAuditorInformation(submission, within10days)

  ]
  // if (within10days) {
  //   newSubs.push(getByDemoCondition3(submission, within10days));
  //   newSubs.push(getByDemoCondition4(submission, within10days));
  // }
  newSubs.forEach(newSub => {
    if (!isBlank(newSub)) {
      subjectivities.push({
        key: nextKey,
        text: newSub
      });
      nextKey += 1;
    }
  })
  return subjectivities;
}

const getSubjectivitiesOCP = (submission, within10days = false) => {
  const subjectivities = within10days ? [] : MANDATORY_SUBJECTIVITIES.slice();
  let nextKey = within10days ? 0 :Math.max.apply(Math, subjectivities.map(sub => sub.key)) + 1;
  const newSubs = [
    getSLBByEffectiveDate(submission, within10days),
    getByProjectName(submission, within10days),
    getByNYCHAProject(submission, within10days),
    getByResidential(submission, within10days),
    getByRenovation(submission, within10days),
    getBySquareFootage(submission, within10days),
    getBysquareFootagePercent(submission, within10days),
    getNumberOfStories(submission, within10days),
    getBySpecificFloorsDetails(submission, within10days),
    getByVerticalExpansion(submission, within10days),
    getByVerticalExpansion2(submission, within10days),
    getByEightfeet(submission, within10days),
    getByDemolitionName(submission, within10days),
    getByDemolitionDetailsStories(submission, within10days),
    getByDemolitionDetailsMethod(submission, within10days),
    getByDemolitionDetailsMonths(submission, within10days),
    getByDemolitionDetailsPrecautions(submission, within10days),
    getByGLExpirationDate(submission, within10days),
    getAuditorInformation(submission, within10days)
  ]
  newSubs.forEach(newSub => {
    if (!isBlank(newSub)) {
      subjectivities.push({
        key: nextKey,
        text: newSub
      });
      nextKey += 1;
    }
  })
  return subjectivities;
}

const getSubjectivities = (submission, within10days = false) => {
  if (submission.type === 'oi') {
    return getSubjectivitiesOI(submission, within10days);
  } else if (submission.type === 'ocp') {
    return getSubjectivitiesOCP(submission, within10days);
  }
}
const updateSubjectivities = (submission, within10days = false, defaultPreference = {}) => {
  const subjectivities = within10days ? submission && submission.ratings && submission.ratings[submission.type] && submission.ratings[submission.type].subjectivities
   : submission && submission.ratings && submission.ratings[submission.type] && submission.ratings[submission.type].subjectivities;
   let nextKey = 1;

  let additionalCoverages = [];
  if (submission && submission.coverages && submission.coverages.gl) {
    additionalCoverages = submission.coverages.gl.additional;
  } else if (defaultPreference) {
    additionalCoverages = defaultPreference;
  }
  const coverageSubj = [
    getSubsidenceRemoval(additionalCoverages, within10days, true),
    getPollutionExclusion(additionalCoverages, within10days, true)
  ];
  let newSubs = [
    getSubsidenceRemoval(additionalCoverages, within10days, false),
    getPollutionExclusion(additionalCoverages, within10days, false)
  ];

  let resetSubj = subjectivities.map(sub => {
    if (coverageSubj.includes(sub.text)) {
      if (!newSubs.includes(sub.text)) {
        return ""
      }
      newSubs = newSubs.filter(subj => {
        if (subj !== sub.text) {
          return subj;
        }
      })
    }
    return sub.text;
  });

  const subj_= [];
  resetSubj = [...resetSubj, ...newSubs];

  new Set(resetSubj).forEach(newSub => {
    if (!isBlank(newSub)) {
      subj_.push({
        key: nextKey,
        text: newSub
      });
      nextKey += 1;
    }
  });
  return subj_;
}
export { getSubjectivities, updateSubjectivities};